import {TranslationKeyGlobal} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_GLOBAL_ID: TranslationResource<TranslationKeyGlobal> = {
  translation: {
    'global:accept': 'Terima',
    'global:accepted': 'Diterima',
    'global:accuracy': 'Akurasi',
    'global:activate': 'Aktifkan',
    'global:activated': 'Diaktifkan',
    'global:add': 'Tambah',
    'global:addNew': 'Tambah Baru',
    'global:addNow': 'Tambahkan',
    'global:additionalDataModalButton': 'Pergi ke Ubah Profil',
    'global:additionalDataModalDescription':
      'Sebelum melanjutkan, mohon daftarkan alamat email kamu pada halaman ubah profil.',
    'global:additionalDataModalTitle': 'Data Tambahan Diperlukan',
    'global:all': 'Semua',
    'global:allContents': 'Semua Konten',
    'global:allDone': 'Selesai!',
    'global:allTime': 'Semua waktu',
    'global:amount': 'Jumlah',
    'global:and': 'dan',
    'global:apply': 'Terapkan',
    'global:areYouSure': 'Apakah kamu yakin?',
    'global:at': 'Di',
    'global:back': 'Kembali',
    'global:backTo': 'Kembali ke {{page}}',
    'global:bad': 'Salah',
    'global:basicPrice': 'Harga Dasar',
    'global:beta': 'Beta',
    'global:buy': 'Beli',
    'global:by': 'Oleh',
    'global:cancel': 'Batal',
    'global:cart': 'Keranjang',
    'global:change': 'Ubah',
    'global:changesSaved': 'Perubahan telah disimpan',
    'global:charCount': '{{count}}/{{max}}',
    'global:chat': 'Obrolan',
    'global:chatTheCreator': 'Chat Kreator',
    'global:checkoutPayment': 'Pembayaran',
    'global:chosen': 'Dipilih',
    'global:city': 'Kota',
    'global:clearAll': 'Hapus Semua',
    'global:close': 'Tutup',
    'global:comment': 'Komentar',
    'global:communities': 'Komunitas',
    'global:complete': 'Selesai',
    'global:confirm': 'Konfirmasi',
    'global:confirmation': 'Konfirmasi',
    'global:confirmed': 'Konfirm',
    'global:congratulations': 'Selamat!',
    'global:connectionInterrupted': 'Koneksi terputus',
    'global:content': 'Konten',
    'global:continue': 'Lanjut',
    'global:copyLink': 'Bagikan Tautan',
    'global:live': 'Live',
    'global:createnickname': 'Buat Nickname',
    'global:createnicknameDesc':
      'Buat nickname untuk melindungi privasimu. Kamu dapat mengubahnya nanti.',
    'global:createnicknameFail': 'Terjadi masalah ketika mengirimkan data kamu',
    'global:creators': 'Kreator',
    'global:currency': 'Mata Uang',
    'global:current': 'Terbaru',
    'global:date': 'Tanggal',
    'global:dateFormat': '{{hour}}j {{minute}}m',
    'global:dateOfBirth': 'Tanggal Lahir',
    'global:day': 'Hari',
    'global:day_plural': 'Hari',
    'global:days': '{{day}} hari',
    'global:delete': 'Hapus',
    'global:deleteContent': 'Hapus Konten',
    'global:deleted': 'Dihapus',
    'global:description': 'Deskripsi',
    'global:disable': 'Nonaktifkan',
    'global:discount': 'Diskon',
    'global:done': 'Selesai',
    'global:download': 'Unduh',
    'global:downloadApp': 'Unduh Aplikasi',
    'global:duplicate': 'Duplikat',
    'global:duration': 'Durasi',
    'global:edit': 'Edit',
    'global:editContent': 'Edit Konten',
    'global:email': 'Email',
    'global:emailNew': 'Email Baru',
    'global:enabledActivated': 'Diaktifkan',
    'global:events': 'Acara',
    'global:expired': 'Kedaluwarsa',
    'global:failed': 'Gagal',
    'global:failedLoad': 'Gagal Untuk Memuat',
    'global:faq': 'FAQ',
    'global:fileName': 'Tampilan Nama File',
    'global:filter': 'Filter',
    'global:flipVertical': 'Balik Vertikal',
    'global:forUser': 'Untuk {{nickname}}',
    'global:fotoyu': 'FotoYu',
    'global:fotoyuAdmin': 'Admin Fotoyu',
    'global:fototree': 'FotoTree',
    'global:fotoyuSupportTeam': 'Tim dukungan FotoYu:',
    'global:free': 'Gratis',
    'global:from': 'Dari',
    'global:generateThumbnail':
      'Membuat thumbnail... Silakan kembali lagi nanti.',
    'global:good': 'Benar',
    'global:guideline': 'Pedoman',
    'global:here': 'di sini',
    'global:high': 'Tinggi',
    'global:hires': 'Hi-Res',
    'global:hour': 'Jam',
    'global:host': 'Host',
    'global:howItWorks': 'Cara Kerja',
    'global:iAgree': 'Saya Setuju',
    'global:iBanking': 'i-Banking',
    'global:iChooseThis': 'Saya memilih ini',
    'global:idr': 'IDR',
    'global:invalidCode': 'Kode tidak valid.',
    'global:invoiceCopied': 'Invoice berhasil disalin',
    'global:isRated': 'Dinilai',
    'global:isThisYou': 'Apakah Ini Kamu?',
    'global:itsMe': 'Iya, ini saya',
    'global:kycModalInfo': 'Langkah selanjutnya akan menyalakan kamera kamu.',
    'global:kycModalSubtitle':
      'Aktifkan RoboYu di aplikasi mobile untuk mencari dokumentasimu dengan teknologi pengenalan wajah.',
    'global:lastCertainDays': '{{days}} hari terakhir',
    'global:later': 'Nanti Saja',
    'global:less': 'lebih sedikit',
    'global:limitedAccess': 'Akses Terbatas',
    'global:limitedAccessDesc': 'Belum memenuhi persyaratan umur.',
    'global:link': 'Tautan',
    'global:linkCopied': 'Tautan berhasil disalin',
    'global:location': 'Lokasi',
    'global:login': 'Masuk',
    'global:loading': 'Memuat...',
    'global:logout': 'Keluar',
    'global:maintenanceEnd': 'hingga <date>{{date}}</date>',
    'global:maintenanceStart': 'pada <date>{{date}}</date>',
    'global:masonryView': 'Tampilan Masonry',
    'global:medium': 'Sedang',
    'global:menu': 'Menu',
    'global:messageError': 'Ups... terjadi sesuatu yang tidak terduga',
    'global:message': 'Pesan',
    'global:messageError_code-400': 'Format data yang dikirim tidak valid',
    'global:messageError_code-401':
      'Akses token yang digunakan sudah tidak valid',
    'global:messageError_code-403': 'Kamu dilarang mengakses fitur ini',
    'global:messageError_code-404': 'Halaman tidak ditemukan',
    'global:messageError_code-408': '$t(global:messageError_timeout)',
    'global:messageError_code-409': 'Data Konflik: ID telah digunakan',
    'global:messageError_no-connection':
      'Nyalakan koneksi internet untuk melanjutkan',
    'global:messageError_timeout': 'Koneksi Terputus',
    'global:messageError-execute':
      'Terjadi kesalahan saat mengeksekusi tindakan. Silakan coba lagi.',
    'global:mfa': 'Autentikasi Multi-Faktor',
    'global:minute': 'Menit',
    'global:mobileNumber': 'Nomor Ponsel',
    'global:mobileNumberNew': 'Nomor Ponsel Baru',
    'global:month': 'Bulan',
    'global:month_april': 'April',
    'global:month_august': 'Agustus',
    'global:month_december': 'Desember',
    'global:month_february': 'Februari',
    'global:month_january': 'Januari',
    'global:month_july': 'Juli',
    'global:month_june': 'Juni',
    'global:month_march': 'Maret',
    'global:month_may': 'May',
    'global:month_november': 'November',
    'global:month_october': 'Oktober',
    'global:month_september': 'September',
    'global:more': 'lebih banyak',
    'global:name': 'Name',
    'global:needHelp': 'Butuh Bantuan?',
    'global:next': 'Lanjut',
    'global:nickname': 'Nickname',
    'global:no': 'Tidak',
    'global:notes': 'Catatan',
    'global:notification': 'Notifikasi',
    'global:notMe': 'Bukan Saya',
    'global:numberCopied': 'Nomor berhasil disalin',
    'global:notRegistered': 'Tidak Terdaftar',
    'global:off': 'Nonaktif',
    'global:ok': 'OK',
    'global:on': 'Aktif',
    'global:open': 'Buka',
    'global:options': 'Pilihan',
    'global:other': 'Lainnya',
    'global:package': 'Paket',
    'global:packages': 'Paket',
    'global:password': 'Kata Sandi',
    'global:passwordConfirm': 'Konfirmasi Kata Sandi',
    'global:phoneNumber': 'Nomor Ponsel',
    'global:photo': 'Foto',
    'global:places': 'Tempat',
    'global:pleaseTryAgain': 'Mohon coba kembali dalam waktu {{countdown}}.',
    'global:pleaseWait': 'Harap tunggu...',
    'global:processed': 'Diproses',
    'global:profile': 'Profil',
    'global:publish': 'Unggah',
    'global:purchaseDate': 'Tanggal pembelian: {{purchased_at}}',
    'global:recentSearch': 'Pencarian Terkini',
    'global:recover': 'Pulihkan',
    'global:recycle': 'Daur Ulang',
    'global:refreshPage': 'Segarkan',
    'global:register': 'Daftar',
    'global:reject': 'Tolak',
    'global:rejected': 'Ditolak',
    'global:remove': 'Hapus',
    'global:removeAll': 'Hapus Semua',
    'global:reply': 'Balasan',
    'global:report': 'Laporkan',
    'global:reportContent': 'Laporkan Konten',
    'global:reportFail': 'Laporan Gagal',
    'global:reportFailMessage':
      'Kesalahan terjadi ketika mengirimkan laporan. Mohon ulangi lagi.',
    'global:reportReason': 'Pilih alasan:',
    'global:reportSuccess': 'Laporan Berhasil!',
    'global:reportSuccessMessage':
      'Terima kasih atas partisipasinya. Kami akan memproses laporan kamu.',
    'global:requested': 'Diminta',
    'global:reset': 'Reset',
    'global:resetAll': 'Reset Semua',
    'global:retry': 'Ulangi',
    'global:revision': 'Revisi',
    'global:rotate': 'Putar Konten',
    'global:rotateLeft': 'Putar Kiri',
    'global:rotateRight': 'Putar Kanan',
    'global:rp': 'Rp',
    'global:save': 'Simpan',
    'global:saveChanges': 'Simpan Perubahan',
    'global:search': 'Cari',
    'global:seeMore': 'Lihat Lebih Banyak',
    'global:select': 'Pilih',
    'global:selectAll': 'Pilih Semua',
    'global:selectedCount': '{{count}} Terpilih',
    'global:selectVideo': 'Pilih video untuk diunggah',
    'global:send': 'Kirim',
    'global:settings': 'Pengaturan',
    'global:setup': 'Pasang',
    'global:share': 'Bagikan',
    'global:shareContent': 'Bagikan Konten',
    'global:shareContentFailed':
      'Tidak dapat membagikan {{type}} saat ini. Silakan coba lagi nanti.',
    'global:signUp': 'Daftar',
    'global:similarAccount': 'Kemungkinan Akun Ganda',
    'global:skip': 'Lewati',
    'global:sorry': 'Maaf!',
    'global:sort': 'Urutkan',
    'global:standard': 'Standar',
    'global:start': 'Mulai',
    'global:step': 'Langkah',
    'global:stop': 'Berhenti',
    'global:stay': 'Tetap di sini',
    'global:submit': 'Simpan',
    'global:success': 'Berhasil!',
    'global:successUpload': 'Sukses',
    'global:sure': 'Ya, saya yakin',
    'global:swipe': 'Geser',
    'global:tapToRetry': 'Ketuk untuk Mencoba Lagi',
    'global:time': 'Waktu',
    'global:title': 'Judul',
    'global:today': 'Hari ini',
    'global:tomorrow': 'Besok',
    'global:to': 'Sampai',
    'global:to_direction': 'Ke',
    'global:transferATM': 'Transfer ATM',
    'global:transferMiniATM': 'Transfer Mini ATM',
    'global:tryAgain': 'Coba Lagi',
    'global:tryRefresh': 'Coba segarkan halaman ini.',
    'global:type': 'Tipe',
    'global:unfollow': 'Berhenti ikuti',
    'global:upgrade': 'Tingkatkan',
    'global:upgradeStatus': 'Status Peningkatan',
    'global:upload': 'Unggah',
    'global:uploadDate': 'Tanggal Unggah: {{date}}',
    'global:uploadedImage': 'Gambar Terunggah',
    'global:uploadVideo': 'Unggah Video',
    'global:uploadVideoOptional': 'Unggah Video (Opsional)',
    'global:username': 'Username',
    'global:validationMaxLength':
      'Formulir ini membutuhkan maksimal {{count}} karakter',
    'global:validationMaxLength_plural':
      'Formulir ini membutuhkan maksimal {{count}} karakter',
    'global:validationMaxPrice': 'Harga maksimum konten adalah {{price}}',
    'global:validationMinLength':
      'Formulir ini membutuhkan setidaknya {{count}} karakter',
    'global:validationMinLength_plural':
      'Formulir ini membutuhkan setidaknya {{count}} karakter',
    'global:validationMinPrice': 'Harga minimum konten adalah {{price}}',
    'global:validationRequired': 'Formulir ini wajib diisi',
    'global:verify': 'Verifikasi',
    'global:video': 'Video',
    'global:waitingAdmin': 'Menunggu Persetujuan Admin',
    'global:whatsapp': 'WhatsApp',
    'global:with': 'Dengan',
    'global:yes': 'Ya',
    'global:yesDelete': 'Ya, Hapus',
    'global:yesImSure': 'Saya yakin',
    'global:yesterday': 'Kemarin',
    'global:yourResponse': 'Respon kamu',
    'global:yuser': 'Yuser',
    'global:yuser_plural': 'Yuser',
  },
}
